import { Address } from "../models/merchant";

interface IPaymodel {
  //#region optional API request parameter
  location: string;
  selectedPromocode: number;
  //#endregion
  inputbox: boolean;
  Totalamount: number;
  Displayamount: number;
  Distance: number;
  isError: boolean;
  userlatitude: number;
  userlongitude: number;
  Addresses: Address;
  isDelivery: boolean;
}
export class Paymodel implements IPaymodel {
  constructor() {
    this.inputbox = false;
    this.isError = false;
    this.isDelivery = false;
  }
  location: string;
  selectedPromocode: number;
  //#endregion
  inputbox: boolean;
  Totalamount: number;
  Displayamount: number;
  Distance: number;
  isError: boolean;
  isDelivery: boolean;
  userlatitude: number;
  userlongitude: number;
  Addresses: Address;
}
interface IFulfillmentmodel {
  istoodle: number;
  isroom: number;
  dynamicTextMessage: string;
  selectedaddress: Address;
  apptype: number;
  orderType: string;
  paymentMethod: string;
  inputbox: boolean;
  selectedTable: any;
  selectedWaiter: any;
  selectedAssignTable: any;
  selectedRoom: any;
  specialInstructions: string;
  assignTableOptions: any;
  tableOptions: any;
  waiterOptions: any;
  roomOptions: any;
  tableOrFulfillmentModal: any;
}
export class Fulfillmentmodel implements IFulfillmentmodel {
  constructor() {
    this.orderType = "";
    this.inputbox = false;
    this.specialInstructions = "";
    this.assignTableOptions = [];
    this.tableOptions = [];
    this.waiterOptions = [];
    this.roomOptions = [];
    this.dynamicTextMessage = "";
  }
  istoodle: number;
  isroom: number;
  dynamicTextMessage: string;
  selectedaddress: Address;
  apptype: number;
  orderType: string;
  paymentMethod: string;
  inputbox: boolean;
  selectedTable: any;
  selectedWaiter: any;
  selectedAssignTable: any;
  selectedRoom: any;
  specialInstructions: string;
  assignTableOptions: any;
  tableOptions: any;
  waiterOptions: any;
  roomOptions: any;
  tableOrFulfillmentModal: any;
  isTip: any;
  tipAmount: any;
  isDeliver: any;
  deliveryFees: number;
  isProcessingFee?: boolean;
  processingFee?: number;
  totalAmountBeforeDiscount?: number;
  vatAmount?: number;
}
